import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { WizardLayout } from '../components/WizardLayout';
import { VehicleCard } from '../components/VehicleCard';
import { useBookingStore } from '../store/bookingStore';
import { useLanguage } from '../locales/LanguageContext';

export const Step1_SelectVehicle = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const quoteData = useBookingStore(state => state.quoteData);
  const selectedVehicle = useBookingStore(state => state.selectedVehicle);
  const setSelectedVehicle = useBookingStore(state => state.setSelectedVehicle);
  const nextStep = useBookingStore(state => state.nextStep);
  
  useEffect(() => {
    if (!quoteData) {
      navigate('/');
    }
  }, [quoteData, navigate]);
  
  const handleNext = () => {
    if (selectedVehicle) {
      nextStep();
      navigate('/booking/service-details');
    }
  };
  
  if (!quoteData) return null;
  
  return (
    <WizardLayout 
      onNext={handleNext}
      canGoNext={!!selectedVehicle}
    >
      <div data-testid="step-select-vehicle">
        <h2 className="font-manrope font-bold text-2xl sm:text-3xl text-navy-950 mb-2">
          {t('step1.title')}
        </h2>
        <p className="text-sm sm:text-base text-slate-600 mb-4 sm:mb-6">
          {t('step1.subtitle')}
        </p>
        
        <div className="grid gap-4 sm:gap-6 md:grid-cols-2">
          {quoteData.items.map((vehicle) => (
            <VehicleCard
              key={vehicle.vehicle_type_id}
              vehicle={vehicle}
              isSelected={selectedVehicle?.vehicle_type_id === vehicle.vehicle_type_id}
              onSelect={() => setSelectedVehicle(vehicle)}
            />
          ))}
        </div>
      </div>
    </WizardLayout>
  );
};
